
import { Component, Vue, Prop } from "vue-property-decorator";
import echarts from "echarts";
import Axios from "axios";
import { GetBoard, GetFlatList } from "@/request/statistics";
@Component({})
export default class Name extends Vue {
  private nowTime = new Date();
  private interval: any = {};
  private institution_id: any = "";
  private disease_id: any = "";
  private ziyuanH: any = document.documentElement.clientHeight * 0.9 * 0.6; //实时屏幕高度
  private mapData: any = [
    { name: "黄浦区", value: 0 },
    { name: "徐汇区", value: 0 },
    { name: "长宁区", value: 0 },
    { name: "静安区", value: 0 },
    { name: "普陀区", value: 0 },
    { name: "虹口区", value: 0 },
    { name: "杨浦区", value: 0 },
    { name: "闵行区", value: 0 },
    { name: "宝山区", value: 0 },
    { name: "嘉定区", value: 0 },
    { name: "浦东新区", value: 0 },
    { name: "金山区", value: 0 },
    { name: "松江区", value: 0 },
    { name: "青浦区", value: 0 },
    { name: "奉贤区", value: 0 },
    { name: "崇明区", value: 0 },
  ];
  private colors: any = [
    "#FFA7CC",
    "#46AAAA",
    "#FFAA6A",
    "#A185D3",
    "#82D1F1",
    "#EC7E68",
    "#F6C63C",
    "#7784A2",
    "#75DDB5",
    "#759FFC",
    "#FFA7CC",
    "#46AAAA",
    "#FFAA6A",
    "#A185D3",
    "#82D1F1",
    "#EC7E68",
    "#F6C63C",
    "#7784A2",
    "#75DDB5",
    "#759FFC",
    "#FFA7CC",
    "#46AAAA",
    "#FFAA6A",
    "#A185D3",
    "#82D1F1",
    "#EC7E68",
    "#F6C63C",
    "#7784A2",
    "#75DDB5",
    "#759FFC",
    "#FFA7CC",
    "#46AAAA",
    "#FFAA6A",
    "#A185D3",
    "#82D1F1",
    "#EC7E68",
    "#F6C63C",
    "#7784A2",
    "#75DDB5",
    "#759FFC",
  ];
  private data: any = {
    主要指标达标分布情况: {
      title: [
        "血压",
        "血糖",
        "血氧饱和度",
        "血脂",
        "心率",
        "体重指数",
        "尿酸",
        "血红蛋白",
        "体温",
        "脉搏",
      ],
      达标人数count: 1992,
      达标率count: 100,
      达标人数: [700, 456, 1900, 567, 1840, 1740, 1230, 1900, 1980, 1890],
      达标率: [35, 23, 95, 28, 92, 87, 62, 95, 99, 95],
    },
  };
  private allData: any = {};
  private chengzailvOption = {
    color: ["#09c8f4"],
    title: {
      subtextStyle: {
        color: "#fff",
      },
    },
    grid: {
      top: 40,
      left: "3%",
      right: "4%",
      bottom: "4%",
      containLabel: true,
    },
    xAxis: [
      {
        type: "category",
        data: ["总体达标人数", "总体达标率"],
        axisTick: {
          show: false,
        },
        axisLabel: {
          color: "#fff",
        },
        axisLine: {
          lineStyle: {
            color: "#09c8f4",
          },
        },
      },
    ],
    yAxis: [
      {
        name: "人",
        type: "value",
        axisLabel: {
          show: true,
          color: "#fff",
          formatter: (axisLabel: any) => {
            return axisLabel;
          },
        },
        axisLine: {
          lineStyle: {
            color: "#09c8f4",
          },
        },
        splitLine: {
          show: true,
          lineStyle: {
            color: ["#09c8f4"],
          },
        },
        axisTick: {
          show: false,
        },
      },
      {
        type: "value",
        name: "%",
        axisLabel: {
          color: "#fff",
          formatter: (axisLabel: any) => {
            return axisLabel;
          },
        },
        axisLine: {
          lineStyle: {
            color: "#09c8f4",
          },
        },
        splitLine: {
          show: true,
          lineStyle: {
            color: ["#09c8f4"],
          },
        },
        axisTick: {
          show: false,
        },
      },
    ],
    series: [
      {
        name: "",
        type: "line",
        // type: "pictorialBar",
        barWidth: "40%",
        symbol: "",
        symbolSize: 0,
        lineStyle: {
          width: 0,
        },
        label: {
          show: false,
          position: "top",
          color: "#fff",
          formatter: (label: any) => {
            return label.data.value;
          },
        },
        data: [
          { name: "总体达标人数", value: "1200" },
        ],
      },
      {
        name: "",
        type: "bar",
        yAxisIndex: 1,
        // type: "pictorialBar",
        barWidth: "40%",
        symbol: "",
        label: {
          show: true,
          position: "top",
          color: "#fff",
          formatter: (label: any) => {
            if (label.data.name == "总体达标人数") {
              return 1200;
            } else {
              return "60%";
            }
          },
        },
        data: [
          { name: "总体达标人数", value: "100" },
          { name: "总体达标率", value: "60" },
        ],
      },
    ],
  };
  private liyonglvOption = {
    color: ["#09c8f4"],
    title: {
      subtext: "人/平方米",
      subtextStyle: {
        color: "#09c8f4",
      },
      right: 0,
    },
    tooltip: {
      show: true,
    },
    grid: {
      top: 40,
      left: "3%",
      right: "10%",
      bottom: "4%",
      containLabel: true,
    },
    xAxis: [
      {
        type: "value",
        data: ["A区", "B区", "C区", "D区", "E区"],
        axisTick: {
          show: false,
        },
        axisLabel: {
          show: false,
          color: "#09c8f4",
        },
        axisLine: {
          show: false,
          lineStyle: {
            color: "#09c8f4",
          },
        },
        splitLine: {
          show: false,
        },
      },
    ],
    yAxis: [
      {
        type: "category",
        axisLabel: {
          show: false,
          color: "#09c8f4",
          formatter: (axisLabel: any) => {
            return axisLabel;
          },
        },
        axisLine: {
          show: false,
          lineStyle: {
            color: "#09c8f4",
          },
        },
        splitLine: {
          show: false,
        },
        axisTick: {
          show: false,
        },
      },
    ],
    series: [
      {
        name: "",
        type: "bar",
        // type: "pictorialBar",
        // barWidth: "60%",
        label: {
          show: true,
          position: "right",
          color: "#09c8f4",
          formatter: (label: any) => {
            return label.data.value;
          },
        },
        data: [
          { name: "A区", value: "20" },
          { name: "B区", value: "60" },
          { name: "C区", value: "10" },
          { name: "D区", value: "40" },
          { name: "E区", value: "100" },
        ],
      },
    ],
  };
  private fuwuOption: any = {
    color: ["#09c8f4", "#F4D612"],
    tooltip: {
      show: true,
    },
    grid: {
      top: 0,
      left: "1%",
      right: "10%",
      bottom: "4%",
      containLabel: true,
    },
    xAxis: [
      {
        type: "value",
        axisTick: {
          show: false,
        },
        axisLabel: {
          show: false,
          color: "#09c8f4",
        },
        axisLine: {
          show: false,
          lineStyle: {
            color: "#09c8f4",
          },
        },
        splitLine: {
          show: false,
        },
      },
    ],
    yAxis: [
      {
        type: "category",
        data: [],
        axisLabel: {
          show: true,
          color: "#fff",
          formatter: (axisLabel: any) => {
            return axisLabel;
          },
        },
        axisLine: {
          show: false,
          lineStyle: {
            color: "#09c8f4",
          },
        },
        splitLine: {
          show: false,
        },
        axisTick: {
          show: false,
        },
      },
    ],
    series: [
      {
        name: "主要慢病年龄分布情况",
        type: "bar",
        label: {
          show: true,
          position: "right",
          color: "#fff",
          formatter: (label: any) => {
            return label.data.value;
          },
        },
        data: [],
      },
    ],
  };
  private jigou1Option = {
    title: {
      text: "三级医疗机构",
      left: "center",
      top: "center",
      textStyle: {
        color: "#09c8f4",
        fontSize: 14,
      },
    },
    color: ["#2F4554", "#D900D6"],
    series: [
      {
        type: "pie",
        radius: ["60%", "90%"],
        avoidLabelOverlap: false,
        hoverAnimation: false,
        label: {
          show: true,
          position: "center",
        },
        labelLine: {
          show: false,
        },
        data: [6900, 300],
      },
    ],
  };
  private jigou2Option = {
    title: {
      text: "二级医疗机构",
      left: "center",
      top: "center",
      textStyle: {
        color: "#09c8f4",
        fontSize: 14,
      },
    },
    color: ["#2F4554", "#F0600A"],
    series: [
      {
        type: "pie",
        radius: ["60%", "90%"],
        avoidLabelOverlap: false,
        hoverAnimation: false,
        label: {
          show: true,
          position: "center",
        },
        labelLine: {
          show: false,
        },
        data: [5900, 1300],
      },
    ],
  };
  private jigou3Option = {
    title: {
      text: "三级医疗机构",
      left: "center",
      top: "center",
      textStyle: {
        color: "#09c8f4",
        fontSize: 14,
      },
    },
    color: ["#2F4554", "#090DF4"],
    series: [
      {
        type: "pie",
        radius: ["60%", "90%"],
        avoidLabelOverlap: false,
        hoverAnimation: false,
        label: {
          show: true,
          position: "center",
        },
        labelLine: {
          show: false,
        },
        data: [1600, 5600],
      },
    ],
  };
  private refresh() {
    this.institution_id = "";
    this.disease_id = "";
    this.getBoard();
    this.drawMap();
  }
  private mapOption = {};
  private drawMap() {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    // 获取json数据
    Axios.get("/static/chengdu.json").then((res) => {
      let data: any = {
        type: res.data.type,
        features: res.data.features,
      };
      const params: any = {
        params: {
          institution_id: "",
          名称: "",
          坐标: [],
        },
      };
      GetFlatList(this, params).then((res: any) => {
        loading.close();
        let pointData: any = [];
        let geoCoordMap: any = [];
        res.forEach((ele: any) => {
          if (ele["坐标"] && ele["坐标"].length > 0) {
            ele.name = ele["名称"];
            const d: any = JSON.parse(JSON.stringify(ele));
            d.value = 0;
            pointData.push(d);
            const geoItem: any = JSON.parse(JSON.stringify(ele));
            geoItem.value = [ele["坐标"][0], ele["坐标"][1], 0];
            geoCoordMap.push(geoItem);
          }
        });
        const eChart: any = echarts.init(this.$refs.map as HTMLCanvasElement);
        echarts.registerMap("shanghai", data);
        const option: any = {
          tooltip: {
            trigger: "item",
            formatter: function (params: any) {
              if (params.data) {
                return params.name;
              }
            },
          },
          toolbox: {
            show: true,
            orient: "vertical",
            left: "right",
            top: "center",
            feature: {
              dataView: { show: false },
              restore: {
                show: false,
              },
              saveAsImage: {
                // 保存图片
                show: false,
              },
            },
          },
          legend: {
            orient: "vertical",
            y: "bottom",
            x: "right",
            data: ["pm2.5"],
            textStyle: {
              color: "#fff",
            },
          },
          //   visualMap: {
          //     show: false,
          //     min: 0,
          //     max: 500,
          //     left: "left",
          //     top: "bottom",
          //     text: ["高", "低"], // 文本，默认为数值文本
          //     calculable: true,
          //     seriesIndex: [1],
          //     inRange: {},
          //   },
          geo: {
            map: "shanghai",
            show: true,
            roam: true,
            label: {
              normal: {
                show: true,
                textStyle: {
                  color: "#fff",
                },
              },
              emphasis: {
                show: true,
                textStyle: {
                  color: "#fff",
                },
              },
            },
            itemStyle: {
              normal: {
                areaColor: "#3a7fd5",
                borderColor: "#0a53e9", //线
                shadowColor: "#092f8f", //外发光
                shadowBlur: 20,
              },
              emphasis: {
                areaColor: "#18EAEA", //悬浮区背景
                // areaColor: "#3a7fd5", //悬浮区背景
              },
            },
          },
          series: [
            {
              symbolSize: 0,
              //   label: {
              //     normal: {
              //       formatter: "{b}",
              //       position: "right",
              //       show: true,
              //     },
              //     emphasis: {
              //       show: true,
              //     },
              //   },
              itemStyle: {
                normal: {
                  color: "#fff",
                },
              },
              name: "light",
              type: "scatter",
              coordinateSystem: "geo",
              data: geoCoordMap,
            },
            {
              type: "map",
              map: "shanghai",
              geoIndex: 0,
              //   aspectScale: 0.75, //长宽比
              showLegendSymbol: false, // 存在legend时显示
              label: {
                normal: {
                  show: true,
                },
                emphasis: {
                  show: true,
                },
              },
              roam: true,
              itemStyle: {
                normal: {
                  areaColor: "#031525",
                  borderColor: "#FFFFFF",
                },
                emphasis: {
                  areaColor: "#2B91B7",
                },
              },
              animation: false,
              data: pointData,
            },
            {
              name: "Top 5",
              type: "scatter",
              coordinateSystem: "geo",
              symbol: "pin",
              symbolSize: [26, 26],
              //   label: {
              //     normal: {
              //       show: true,
              //       textStyle: {
              //         color: "#fff",
              //         fontSize: 9,
              //       },
              //       formatter(value: any) {
              //         return value.data.value[2];
              //       },
              //     },
              //   },
              itemStyle: {
                normal: {
                  color: "#D8BC37", //标志颜色
                },
              },
              data: geoCoordMap,
              showEffectOn: "render",
              rippleEffect: {
                brushType: "stroke",
              },
              hoverAnimation: true,
              zlevel: 1,
            },
          ],
        };
        eChart.setOption(option, true);
        // 点击事件
        eChart.off("click");
        eChart.on("click", (p: any) => {
          console.log(p);
          if (p.data.institution_id) {
            this.institution_id = p.data.institution_id;
            this.disease_id = "";
            this.getBoard();
          }
        });
      });
      //   Axios.get("/static/shequ.json").then((d: any) => {
      //     let pointData: any = [];
      //     let geoCoordMap: any = [];
      //     d.data.forEach((item: any) => {
      //       if (item["行政区划"] === "静安区") {
      //         item.name = item["机构名称"];
      //         const shequItem: any = JSON.parse(JSON.stringify(item));
      //         shequItem.value = 0;
      //         pointData.push(shequItem);
      //         const geoItem: any = JSON.parse(JSON.stringify(item));
      //         geoItem.value = [geoItem["经度"], geoItem["纬度"], 0];
      //         geoCoordMap.push(geoItem);
      //       }
      //     });
      //     console.log(123);
      //     console.log(pointData);
      //     console.log(geoCoordMap);
      //     const eChart: any = echarts.init(this.$refs.map as HTMLCanvasElement);
      //     echarts.registerMap("shanghai", data);
      //     const option: any = {
      //       tooltip: {
      //         trigger: "item",
      //         formatter: function (params: any) {
      //           if (params.data) {
      //             return params.name;
      //           }
      //         },
      //       },
      //       toolbox: {
      //         show: true,
      //         orient: "vertical",
      //         left: "right",
      //         top: "center",
      //         feature: {
      //           dataView: { show: false },
      //           restore: {
      //             show: false,
      //           },
      //           saveAsImage: {
      //             // 保存图片
      //             show: false,
      //           },
      //         },
      //       },
      //       legend: {
      //         orient: "vertical",
      //         y: "bottom",
      //         x: "right",
      //         data: ["pm2.5"],
      //         textStyle: {
      //           color: "#fff",
      //         },
      //       },
      //       //   visualMap: {
      //       //     show: false,
      //       //     min: 0,
      //       //     max: 500,
      //       //     left: "left",
      //       //     top: "bottom",
      //       //     text: ["高", "低"], // 文本，默认为数值文本
      //       //     calculable: true,
      //       //     seriesIndex: [1],
      //       //     inRange: {},
      //       //   },
      //       geo: {
      //         map: "shanghai",
      //         show: true,
      //         roam: true,
      //         label: {
      //           normal: {
      //             show: true,
      //             textStyle: {
      //               color: "#fff",
      //             },
      //           },
      //           emphasis: {
      //             show: true,
      //             textStyle: {
      //               color: "#fff",
      //             },
      //           },
      //         },
      //         itemStyle: {
      //           normal: {
      //             areaColor: "#3a7fd5",
      //             borderColor: "#0a53e9", //线
      //             shadowColor: "#092f8f", //外发光
      //             shadowBlur: 20,
      //           },
      //           emphasis: {
      //             areaColor: "#18EAEA", //悬浮区背景
      //             // areaColor: "#3a7fd5", //悬浮区背景
      //           },
      //         },
      //       },
      //       series: [
      //         {
      //           symbolSize: 0,
      //           //   label: {
      //           //     normal: {
      //           //       formatter: "{b}",
      //           //       position: "right",
      //           //       show: true,
      //           //     },
      //           //     emphasis: {
      //           //       show: true,
      //           //     },
      //           //   },
      //           itemStyle: {
      //             normal: {
      //               color: "#fff",
      //             },
      //           },
      //           name: "light",
      //           type: "scatter",
      //           coordinateSystem: "geo",
      //           data: geoCoordMap,
      //         },
      //         {
      //           type: "map",
      //           map: "shanghai",
      //           geoIndex: 0,
      //           //   aspectScale: 0.75, //长宽比
      //           showLegendSymbol: false, // 存在legend时显示
      //           label: {
      //             normal: {
      //               show: true,
      //             },
      //             emphasis: {
      //               show: true,
      //             },
      //           },
      //           roam: true,
      //           itemStyle: {
      //             normal: {
      //               areaColor: "#031525",
      //               borderColor: "#FFFFFF",
      //             },
      //             emphasis: {
      //               areaColor: "#2B91B7",
      //             },
      //           },
      //           animation: false,
      //           data: pointData,
      //         },
      //         {
      //           name: "Top 5",
      //           type: "scatter",
      //           coordinateSystem: "geo",
      //           symbol: "pin",
      //           symbolSize: [26, 26],
      //           //   label: {
      //           //     normal: {
      //           //       show: true,
      //           //       textStyle: {
      //           //         color: "#fff",
      //           //         fontSize: 9,
      //           //       },
      //           //       formatter(value: any) {
      //           //         return value.data.value[2];
      //           //       },
      //           //     },
      //           //   },
      //           itemStyle: {
      //             normal: {
      //               color: "#D8BC37", //标志颜色
      //             },
      //           },
      //           data: geoCoordMap,
      //           showEffectOn: "render",
      //           rippleEffect: {
      //             brushType: "stroke",
      //           },
      //           hoverAnimation: true,
      //           zlevel: 1,
      //         },
      //       ],
      //     };
      //     eChart.setOption(option, true);
      //     loading.close();
      //   });
    });
  }
  private shuaxin() {
    this.disease_id = "";
    this.getBoard();
  }
  private getBoard() {
    const params: any = {
      institution_id: this.institution_id,
      disease_id: this.disease_id,
    };
    GetBoard(this, params).then((res: any) => {
      this.allData = res;
      const ageTitle: any = [];
      this.allData.age_pie.forEach((ele: any) => {
        ageTitle.push(ele.name);
      });
      console.log(ageTitle);
      this.allData.ageTitle = ageTitle;
      this.fuwuOption.yAxis[0].data = ageTitle;
      this.fuwuOption.series[0].data = this.allData.age_pie;
      this.drawResult();
    });
  }
  /**
   * 主要慢病分布情况
   */
  private drawResult() {
    const Chart: any = echarts.init(this.$refs.result as HTMLCanvasElement);
    const options = {
      color: this.colors,
      tooltip: {
        trigger: "item",
        formatter: "{b0}: {c0}<br />{d}%",
      },
      //   legend: {
      //     orient: "horizontal",
      //     bottom: "6",
      //   },
      series: [
        {
          type: "pie",
          data: this.allData.disease_pie,
          radius: "70%",
          //   label: {
          //     show: false,
          //     position: "center",
          //   },
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: "rgba(0, 0, 0, 0.5)",
            },
          },
          //   center: ["60%", "50%"],
        },
      ],
    };
    Chart.setOption(options, true);
    // 点击事件
    Chart.off("click");
    Chart.on("click", (p: any) => {
      console.log(p);
      this.disease_id = p.data.id;
      this.getBoard();
    });
  }
  private mounted() {
    this.interval = setInterval(() => {
      this.nowTime = new Date();
    }, 1000);
    this.drawMap();
    this.getBoard();
  }
}
